module.exports = __webpack_public_path__ + "media/images/emblems/Oberlangenegg-coat_of_arms-1d707421f622b172df4b2e79b67bafe8.svg";